module.exports = __webpack_public_path__ + "img/green.1f830a34.svg";